import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { backgroundAlt, borderOutline, darkGrayFontColor, destructive, white } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		height: '100%',
	},
	layout: {
		display: 'flex',
		height: '100%',
		minHeight: 0,
		backgroundColor: backgroundAlt,
		width: '100%',
	},
	contentExtras: {
		flex: 1,
		paddingLeft: 28,
		paddingRight: 28,
	},
	contentLoading: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		paddingTop: 20,
		paddingBottom: 20,
		paddingLeft: 28,
		paddingRight: 28,
		minHeight: 0,
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minHeight: 400,
		gap: 16,
	},
	loadingText: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
	},
	errorContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minHeight: 400,
		gap: 12,
		padding: 32,
		textAlign: 'center',
	},
	errorTitle: {
		fontSize: 20,
		fontWeight: 600,
		color: destructive,
		margin: 0,
	},
	errorMessage: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
		maxWidth: 500,
	},
	actionBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 16,
		padding: '12px 16px',
		backgroundColor: white,
		borderRadius: 8,
		border: `1px solid ${borderOutline}`,
		flexWrap: 'wrap',
	},
	actionBarLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		minWidth: 220,
	},
	actionBarRight: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		flexWrap: 'wrap',
		justifyContent: 'flex-end',
		marginLeft: 'auto',
	},
	unpublishedBadge: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		padding: '6px 12px',
		backgroundColor: THEME.colors.danger.light,
		color: THEME.colors.danger.main,
		borderRadius: 16,
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: '0.5px',
	},
	statusText: {
		fontSize: 13,
		fontWeight: 500,
		color: darkGrayFontColor,
	},
});
